import { render, staticRenderFns } from "./EpicRow.vue?vue&type=template&id=07733a49&scoped=true&"
import script from "./EpicRow.vue?vue&type=script&lang=ts&"
export * from "./EpicRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07733a49",
  null
  
)

export default component.exports